// extracted by mini-css-extract-plugin
export default {"wrapper":"CreateTeamPopupFormSteps_wrapper__Lph0V"};